class StickyHeader extends HTMLElement {
  constructor() {
    super();

    this.targets = document.querySelectorAll("[data-header-target]");
    this.sticking = false;

    const setHeightVariable = () =>
      document.documentElement.style.setProperty(
        "--header-height",
        `${this.getBoundingClientRect().height}px`,
      );
    window.requestAnimationFrame(setHeightVariable);
    window.addEventListener("resize", setHeightVariable);

    this._moveStickTarget();
    this._initObserver();

    // Transparency handling
    document.body.classList.add("header-loaded");
  }

  _initObserver() {
    const cb = (entries) => {
      entries.forEach((entry) => {
        switch (entry.target.dataset.headerTarget) {
          case "stick":
            this.sticking = !entry.isIntersecting;
            this.classList.toggle("sticking", this.sticking);
            document.body.classList.toggle("header--sticking", this.sticking);
            break;
        }
      });
    };

    const observer = new IntersectionObserver(cb, {});
    this.targets.forEach((target) => observer.observe(target));
  }

  _moveStickTarget() {
    // Moving this element in editor messes things up (sections disappear when you change things)
    // so just skip.
    if (Shopify?.designMode) return;

    // Move stick target before header (but after promo bar, if present)
    // We can't directly place the target there because these are both
    // sections in a section group.
    const target = document.querySelector('[data-header-target="stick"]');
    const header = this.closest(".shopify-section--header");
    header.parentNode.insertBefore(target, header);
  }
}

if (!customElements.get("sticky-header")) {
  customElements.define("sticky-header", StickyHeader);
}
